"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
exports.default = (function () {
    var _a, _b;
    return (React.createElement("div", { className: 'bg-fire-bush text-white text-uppercase padding-vertical-1 position-absolute bottom-0 width-100', style: { letterSpacing: 1, borderRadius: '10px 10px 0 0', fontSize: '0.75rem' } },
        React.createElement("div", { className: 'flex-container align-middle align-center', style: { paddingBottom: 20 } },
            React.createElement("img", { src: (_b = (_a = window.bundlerApp) === null || _a === void 0 ? void 0 : _a.iconUrls) === null || _b === void 0 ? void 0 : _b.warning }),
            React.createElement("div", { className: 'position-relative', style: { left: 5, top: 1 } }, "Low Stock"))));
});
